export const LogoMark = ({ size = 34 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#121018" stroke="#282338" />
    <path
      d="M32 8 L37 27 L56 32 L37 37 L32 56 L27 37 L8 32 L27 27 Z"
      fill="#E6C594"
    />
    <circle cx="32" cy="32" r="4.5" fill="#D92B34" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark size={compact ? 30 : 36} />
    <span className="leading-none">
      <span className="font-serif-display block text-lg sm:text-xl font-bold tracking-tight text-[#F4F1EE]">
        Musica <span className="italic text-gold-gradient">&amp; Moda</span>
      </span>
      <span className="font-mono-label block text-[10px] tracking-[0.35em] text-[#E6C594] mt-1">
        5.0 — AGENZIA
      </span>
    </span>
  </span>
);
